import { z } from "zod";
import { TObjectBase } from "../base";

export type IRawChat = z.infer<typeof TRawChat>;
export const TRawChat = z
  .object({
    name: z.string().optional(),
    members: z
      .record(
        z.object({
          lastSeenMessage: z.string().optional(),
        })
      )
      .optional(),
    lastMessage: z.string().optional(),
    updatedAt: z.string().optional(),
    deviation: z.string().optional(),
    messages: z
      .object({
        id: z.string(),
        message: z.string(),
        sendDate: z.string().datetime(),
        senderID: z.string(),
      })
      .optional(),
  })
  .extend(TObjectBase.shape);
